import {
  StyledEndpointsContainer,
  StyledEndpointUrl,
  StyledHorizontalRule,
  StyledTagDescription,
  StyledTagHeader,
  StyledEndpointSection,
} from "components/apiDocs/BrowseAllPage/style";
import {
  ApiData,
  Endpoint,
  Tag,
} from "models/apiDocumentation/apiDocumentationModels";
import React from "react";
import { Link } from "react-router-dom";
import { SearchBarOption } from "utils/fuzzyApiHelpers";
import routeConstants from "utils/routeConstants";

const MAX_URL_LENGTH_FOR_TWO_COLUMNS = 50;

interface Props {
  tag: Tag;
  apiData: ApiData;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const EndPoint = ({
  endpoint,
}: {
  endpoint: Endpoint | SearchBarOption;
}) => (
  <StyledEndpointSection data-test-id="endpoint-section">
    <StyledEndpointUrl>
      <Link to={`${routeConstants.apiDocs}/endpoint${endpoint.url}`}>
        GET {endpoint.url}
      </Link>
    </StyledEndpointUrl>
    {endpoint.summary}
  </StyledEndpointSection>
);

const TagSection: React.FC<Props> = ({ tag, apiData }) => {
  const matchingEndpoints = [...apiData.endpoints]
    .filter((endpoint) => endpoint.tag === tag.name)
    .sort((a, b) => (a.url > b.url ? 1 : -1));

  return (
    <li>
      <StyledTagHeader data-test-id="tag-heading">{tag.name}</StyledTagHeader>
      <StyledTagDescription>{tag.description}</StyledTagDescription>
      <StyledHorizontalRule />
      <StyledEndpointsContainer
        singleColumn={matchingEndpoints.some(
          (e) => e.url.length > MAX_URL_LENGTH_FOR_TWO_COLUMNS
        )}
      >
        {matchingEndpoints.map((e) => (
          <EndPoint endpoint={e} key={e.url} />
        ))}
      </StyledEndpointsContainer>
    </li>
  );
};

export default TagSection;
